/**
 * Pobyt osoby ve složce; načítá se přes `folderPerson.history` s filtrem `activeAt`, protože
 * rozhoduje, kdo ve složce byl v době konání práce, ne kdo v ní je teď.
 */
export const getFolderPersonHistoryFrag = `
    id
    folderId
    personId
    person {
        id
        name
        surname
        titleBeforeName
        titleAfterName
        birthSurname
        alias
        sex
        birthdate
        dateDeath
        image
    }
`;
